import { render, staticRenderFns } from "./myCenter.vue?vue&type=template&id=614391cf&scoped=true&"
import script from "./myCenter.vue?vue&type=script&lang=js&"
export * from "./myCenter.vue?vue&type=script&lang=js&"
import style0 from "./myCenter.vue?vue&type=style&index=0&id=614391cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614391cf",
  null
  
)

export default component.exports